import { useState, useCallback } from "react";

/**
 * Confirmation dialog hook
 * Provides a clean API for showing confirmation dialogs
 */
export function useConfirm() {
  const [dialog, setDialog] = useState(null);

  const confirm = useCallback(
    ({
      title,
      message,
      confirmText,
      cancelText,
      variant = "danger",
    }) => {
      return new Promise((resolve) => {
        setDialog({
          title,
          message,
          confirmText,
          cancelText,
          variant,
          onConfirm: () => {
            setDialog(null);
            resolve(true);
          },
          onCancel: () => {
            setDialog(null);
            resolve(false);
          },
        });
      });
    },
    []
  );

  return { dialog, confirm };
}
